module.exports = __webpack_public_path__ + "img/9.38829d6.png";